import React, { useState } from 'react';
import axios from 'axios';

const LoginB2b = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  // const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`/api/b2b/login`, {
        email,
        password,
      });

      localStorage.setItem('token_b2b', res.data.token);
      alert('Connexion réussie !');
      window.location.href = '/catalogue-b2b'; // redirection après connexion
    } catch (err) {
      alert(err.response?.data?.message || 'Erreur login');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img
          src="/assets/svg/logos/logo.svg"
          alt="KeplerLogo"
          width="258px"
          style={{ display: 'flex', margin: '0px auto' }}
        />
        <h2>Connexion B2B</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email :</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="ex: user@b2b.com"
            />
          </div>

          <div className="form-group">
            <label>Mot de passe :</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Votre mot de passe"
            />
          </div>

          <button type="submit" className="submit-btn" disabled={loading}>
             {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginB2b;
